import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const Button = ({
    children,
    text,
    variant = 'primary',
    size = 'medium',
    shape = 'default',
    type = 'button',
    disabled = false,
    onClick,
    className = '',
    fullWidth = false,
    ...props
}) => {
    const buttonClasses = [
        'button',
        `button--${variant}`,
        `button--${size}`,
        shape === 'pill' ? 'button--pill' : '',
        fullWidth ? 'button--full-width' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            type={type}
            className={buttonClasses}
            disabled={disabled}
            onClick={onClick}
            {...props}
        >
            {children || text}
        </button>
    );
};

Button.propTypes = {
    children: PropTypes.node,
    text: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'gradient']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    shape: PropTypes.oneOf(['default', 'pill']),
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    fullWidth: PropTypes.bool,
};

export default Button;
